import * as types from '../mutation-types';
import * as apis from '../../apis';
import * as R from 'ramda';
import moment from "moment";
import router from '../../router';

const state = {
    order: {
        id: 0,
        tip_price: null,
        reserved_at: null,
        expected_price: null,
        coupon_id: null,
        type: null,
        agreement_id: null,
        pay: null,
        note: '',
        locations: [],
        lastLocation: {},
        no_touch: 0,
        wash_count: 1,
        driver: null,
        confirmDriver: null,
        behalf_fee_vat: null,
    },
    trial: {
        base: 119,
        distance: 0,
        multiple: 0,
        tip: 0,
        discount: 0,
        discount_surplus: 0,
        discount_max: 0,
        night_surcharge: false,
        location_distance: 0,
        location_duration: 0,
        order_duration: 0,
    },
    coupon: null,
    photos:{},
};

const getters = {
    cart: state => state.order,
    cartLocations: state => state.order.locations,
    cartLocationById: state => key => state.order.locations[key],
    cartLastLocation: state => state.order.lastLocation,
    findShopLocationIndex: state => shopId => state.order.locations.findIndex(location => location.shop_id == shopId),
    cartPriceTotal: (state, getter) => Math.max(getter.cartPrice + getter.cartProductPrice + getter.cartExpectedPrice - parseInt(state.trial.discount_surplus || 0), 0),
    cartPrice: (state) => Math.max(parseInt(state.trial.base || 0) + parseInt(state.trial.distance || 0) + parseInt(state.trial.multiple || 0) + parseInt(state.trial.tip || 0) - parseInt(state.trial.discount || 0) + parseInt(state.trial.wait || 0), 0),
    cartProductPrice: state => state.order.locations.filter(location => location.products).reduce((amount, location) => amount + location.products.filter(product => !product.is_elastic).reduce((amount, product) => amount + (product.sumPrice * product.count), 0), 0),
    cartCount: state => state.order.locations.filter(location => location.products).reduce((count, location) => count + location.products.length + (location.note ? 1 : 0), 0),
    cartMinutes: state => Math.ceil(state.trial.order_duration / 60),
    cartExpectedPrice: state => state.order.locations.reduce((amount, location) => parseInt(location.expectedPrice || '0') + amount, 0) + parseInt(state.order.lastLocation.expectedPrice || '0'),
    cartCoupon: state => state.coupon,
    discount: state => parseInt(state.trial.discount || 0),
    discountSurplus: state => parseInt(state.trial.discount_surplus || 0),
    cartTrial: state => state.trial,
    subsidyPrice: state => state.trial.subsidy || 0,
    subsidyNote: state => state.trial.subsidy_note || '',
    cartId: state => state.order.id,
};

function checkShopsWork(locations, nowAt) {
    let promises = locations.filter(location => location.shop_id)
        .map((location) => {
            return apis.getShop({id: location.shop_id}).then(res => res.data).catch(() => null);
        });

    let now = nowAt ? moment(nowAt) : moment();
    return Promise.all(promises).then(shops => {
        return shops.filter(shop => shop)
            .map(shop => {
                if (!shop.opening_hours || !shop.opening_hours.length) {
                    return false;
                }

                let weekdays = shop.opening_hours.filter(opening => opening.type === 'open' && opening.weekday === now.day());
                let workWeekdays = weekdays.filter(day => {
                    let nowAt = now.format('HH:mm');
                    let beganAt = moment(day.began_at).format('HH:mm');
                    let endedAt = moment(day.ended_at).format('HH:mm');
                    return day.is_all_day || (nowAt >= beganAt && nowAt < endedAt);
                });

                if (!workWeekdays.length) {
                    return {
                        alias: shop.alias,
                        message: '已結束',
                    }
                }

                let delayNow = now.clone().add(30, "minutes");
                let delayWeekdays = shop.opening_hours.filter(opening => opening.type === 'open' && opening.weekday === delayNow.day());
                let workDelayWeekdays = delayWeekdays.filter(day => {
                    let delayNowAt = delayNow.format('HH:mm');
                    let beganAt = moment(day.began_at).format('HH:mm');
                    let endedAt = moment(day.ended_at).format('HH:mm');
                    return day.is_all_day || (delayNowAt >= beganAt && delayNowAt < endedAt);
                });

                if (!workDelayWeekdays.length) {
                    return {
                        alias: shop.alias,
                        message: '即將結束',
                    }
                }

                return false;
            })
            .filter(shop => shop);
    });
}

const actions = {
    async sendCart({ commit, state, rootState }, noCheck = false){
        let t = null;
        if (!state.order.type) {
            if (router.currentRoute.meta.createOrderPage)
                t = router.currentRoute.name;
            if (router.currentRoute.meta.name === 'checkout')
                t = router.currentRoute.params.type;
        }

        let payload = {
            'name': rootState.user.user.name,
            'phone': rootState.user.user.phone,
            'note': state.order.note,
            // 'expected_price': state.order.expected_price,
            'type': state.order.type || t,
            'reserved_at': state.order.reserved_at,
            'tip_price': state.order.tip_price,
            'other': {
                'wait_hours': state.order.wait_hours || 0,
                'no_touch': state.order.no_touch || false,
                'wash_count': state.order.wash_count || 1,
            }
        };

        if (state.order.behalf_fee_vat) {
            payload.fee_vat =  state.order.behalf_fee_vat;
        }

        if (state.coupon) {
            payload.coupon_id = state.coupon.id;
        }

        if (state.order.confirmDriver) {
            payload.designated_driver_id = state.order.confirmDriver.id;
        }

        let locations = R.clone(state.order.locations);
        if (!noCheck && state.order.type !== 'liquor') {
            let checkMsgArr = await checkShopsWork([].concat(locations, [R.clone(state.order.lastLocation)]), state.order.reserved_at)
            if (checkMsgArr.length) {
                return Promise.reject({
                    is_not_work: true,
                    messages: checkMsgArr,
                });
            }
        }

        if (state.order.type === 'wash') {
            locations = [].concat([R.clone(state.order.lastLocation)]);
            let res = await apis.getNearbyShops({
                latitude: state.order.lastLocation.latitude,
                longitude: state.order.lastLocation.longitude,
                category_id: 57,
                is_open: 1,
                reserved_at: payload.reserved_at,
            });
            let shops = res.data.data;
            if (shops.length) {
                locations.push({
                    shop_id: shops[0].id,
                    alias: shops[0].alias,
                    city: shops[0].city,
                    district: shops[0].district,
                    road: shops[0].road,
                    additional: shops[0].additional,
                    latitude: shops[0].latitude,
                    longitude: shops[0].longitude,
                    vat: '',
                    note: '',
                    isInsulation: false,
                    isSelfBuy: false,
                    products: [],
                });
            } else {
                return Promise.reject({
                    response: {
                        data: {
                            message: '您附近目前找不到營業中的店家。',
                        }
                    }
                });
            }
        }

        if (state.order.type === 'liquor' && locations.length) {
            let res = await apis.getNearbyShops({
                latitude: state.order.lastLocation.latitude,
                longitude: state.order.lastLocation.longitude,
                category_id: 58,
                is_open: 1,
                reserved_at: payload.reserved_at,
            });
            let shops = res.data.data;
            if (shops.length) {
                locations[0].alias = shops[0].alias;
                locations[0].city = shops[0].city;
                locations[0].district = shops[0].district;
                locations[0].road = shops[0].road;
                locations[0].additional = shops[0].additional;
                locations[0].latitude = shops[0].latitude;
                locations[0].longitude = shops[0].longitude;
            } else {
                return Promise.reject({
                    response: {
                        data: {
                            message: '您附近目前找不到營業中的店家。',
                        }
                    }
                });
            }
        }

        if (state.order.type !== 'transport') {
            locations = locations.concat([state.order.lastLocation]);
        }

        payload.locations = R.map(location => {
            location = R.clone(location);

            if (location.isSave) {
                location.is_save = true;
            }

            if (location.expectedPrice) {
                location.expected_price = location.expectedPrice;
            }

            location.options = {
                'is_self_buy': location.isSelfBuy || false,
                'self_buy_name': location.selfBuyName || '',
                'self_buy_phone': location.selfBuyPhone || '',
                'is_insulation': location.isInsulation || false,
                'is_round_trip': location.isRoundTrip || false,
                'vat': location.vat || '',
                'expected_price': location.expectedPrice || '',
            }

            return location;
        }, R.filter(location => location.latitude, locations));

        if (rootState.user.isLineMini && liff.isInClient()) {
            payload.mini_token = liff.getAccessToken();
        }

        return apis.createOrder(payload).then(res => {
            commit(types.SET_CART_ID, res.data.order);
            commit(types.SAVE_LOCAL_STORAGE_CART);
        }).catch(err => {
            apis.log({
                device_id: 'web',
                action: 'create_order_error',
                data: JSON.stringify({
                    route: {
                        href: window.location.href,
                        name: router.currentRoute.name,
                        path: router.currentRoute.path,
                        query: router.currentRoute.query,
                        params: router.currentRoute.params,
                        fullPath: router.currentRoute.fullPath,
                    },
                    token: localStorage.getItem('token'),
                    message: err.response.data,
                    payload: payload,
                })
            });
            return Promise.reject(err);
        });
    },
    async initLiquorShopLocation({state, dispatch}) {
        if (state.order.type === 'liquor' && state.order.locations.length && state.order.lastLocation.latitude) {
            let res = await apis.getNearbyShops({
                latitude: state.order.lastLocation.latitude,
                longitude: state.order.lastLocation.longitude,
                category_id: 58,
                is_open: 1,
                reserved_at: state.order.reserved_at,
            });
            let shops = res.data.data;
            if (shops.length) {
                let location = R.clone(state.order.locations[0]);
                location.alias = shops[0].alias;
                location.city = shops[0].city;
                location.district = shops[0].district;
                location.road = shops[0].road;
                location.additional = shops[0].additional;
                location.latitude = shops[0].latitude;
                location.longitude = shops[0].longitude;
                await dispatch('putCartLocation', {key: 0, location: location})
            }
        }
    },
    copyBuyOrder({ dispatch, commit }, order) {
        return new Promise((resolve) => {
            dispatch('clearCart', order.type);
            // dispatch('setCartData', {
            //     value: parseInt(order.expected_price),
            //     key: 'expected_price'
            // });

            let locations = order.locations;
            let lastLocation = null;
            if (['buy', 'set', 'wash', 'liquor'].includes(order.type)) {
                lastLocation = locations.slice(locations.length - 1, locations.length);
                locations = locations.slice(0, locations.length - 1);
            }

            if (order.type === 'wash') {
                locations = [];
            }

            if ((order.type === 'wait' || order.type === 'housekeeping' || order.type === 'accompanying') && order.other) {
                dispatch('setCartData', {
                    value: parseInt(order.other.wait_hours),
                    key: 'wait_hours'
                });
            }

            if (order.type === 'wash' && order.other) {
                dispatch('setCartData', {
                    value: parseInt(order.other.wash_count) || 1,
                    key: 'wash_count'
                });
            }

            locations = R.map(data => {
                return {
                    shop_id: data.shop_id,
                    alias: data.alias,
                    city: data.city,
                    district: data.district,
                    road: data.road,
                    additional: data.additional,
                    note: data.note,
                    latitude: data.latitude,
                    longitude: data.longitude,
                    name: data.name,
                    phone: data.phone,
                    products: data.snapshot,
                    isSelfBuy: data.options.is_self_buy || false,
                    selfBuyName: data.options.self_buy_name || '',
                    selfBuyPhone: data.options.self_buy_phone || '',
                    isInsulation: data.options.is_insulation || false,
                    vat: data.options.vat || '',
                    expectedPrice: data.expected_price ? data.expected_price.toString() : '',
                }
            }, locations);

            if (lastLocation) {
                let last = lastLocation[0];
                commit(types.PUT_CART_LAST_LOCATION, {
                    shop_id: last.shop_id,
                    alias: last.alias,
                    city: last.city,
                    district: last.district,
                    road: last.road,
                    additional: last.additional,
                    note: last.note,
                    latitude: last.latitude,
                    longitude: last.longitude,
                    name: last.name,
                    phone: last.phone,
                    expectedPrice: last.expected_price ? last.expected_price.toString() : '',
                });
            }

            let page = 'buy';
            switch (order.type) {
                case 'buy':
                    page = 'buy';
                    break;
                case 'transport':
                case 'delivery':
                    page = 'transport';
                    break;
                case 'elastic':
                    page = 'elastic';
                    break;
                case 'pay':
                    page = 'pay';
                    break;
                case 'wait':
                    page = 'wait';
                    break;
                case 'set':
                    page = 'set';
                    break;
                case 'liquor':
                    page = 'liquor';
                    break;
                case 'wash':
                    page = 'wash';
                    break;
                case 'housekeeping':
                    page = 'housekeeping';
                    break;
                case 'accompanying':
                    page = 'accompanying';
                    break;
            }

            let shopsChecked = [];
            R.map(data => {
                if (data.shop_id) {
                    shopsChecked.push([data.shop_id, false]);
                }
            }, locations);

            if (shopsChecked.length) {
                let products = [];
                R.map(([shopId, checked]) => {
                    if (! checked) {
                        apis.getShop({id: shopId}).then(res => {
                            products = res.data.categories.reduce((arr, value) => {
                                return arr.concat(value.products);
                            }, products);
                            shopsChecked[shopsChecked.findIndex(arr => arr[0] == shopId)] = true;
                            if (! R.filter(id => id !== true, shopsChecked).length) {
                                let ls = R.map(location => {
                                    let lps = location.products.filter(lp => {
                                        let po = R.find(p => p.id == lp.id)(products);
                                        if (! po) {
                                            return false;
                                        }

                                        if (lp.hasOwnProperty('is_elastic')) {
                                            if (lp.is_elastic !== po.is_elastic) return false;
                                        }

                                        let items = R.flatten(po.options.map(option => option.items)).filter(i => i.is_enable).map(i => i.id);

                                        return lp.options.map(lpo => lpo.id).filter(lpid => items.findIndex(i => i == lpid) < 0).length === 0;
                                    });

                                    location.products = lps;
                                    return location;
                                }, locations);
                                commit(types.SET_CART_LOCATIONS, ls);
                                commit(types.SAVE_LOCAL_STORAGE_CART);
                                dispatch('trialCalculate', order.type);
                                resolve(page);
                            }
                        })
                    }
                }, shopsChecked);
            } else {
                commit(types.SET_CART_LOCATIONS, locations);
                commit(types.SAVE_LOCAL_STORAGE_CART);
                dispatch('trialCalculate', order.type);
                resolve(page);
            }
        });
    },
    initLastLocation({ commit, rootState }, type) {
        if (! ['buy', 'wash'].includes(type)) {
            return;
        }

        let address = rootState.user.addresses.find(address => address.is_default);
        if (!address) {
            commit(types.INIT_CART_LAST_LOCATION, {
                alias: '',
                city: '',
                district: '',
                road: '',
                additional: '',
                note: '',
                latitude: '',
                longitude: '',
                name: rootState.user.user.name,
                phone: rootState.user.user.phone,
            });
        } else {
            commit(types.INIT_CART_LAST_LOCATION, R.clone(address));
        }

        commit(types.SAVE_LOCAL_STORAGE_CART, type);
    },
    initCart({ commit, state, dispatch }, type) {
        let cartOrder = localStorage.getItem(`cart-order-${type}`);
        if (! cartOrder) {
            commit(types.INIT_CART, type);
            dispatch('initLastLocation', type);
            dispatch('trialCalculate', type);

            return;
        }

        commit(types.INIT_TRIAL);
        commit(types.LOAD_LOCAL_STORAGE_CART, JSON.parse(cartOrder));
        dispatch('trialCalculate', type);

        if (! state.order.id) {
            return {id: 0, status: null};
        }

        return apis.getOrder(state.order.id).then(res => {
            let orderId = res.data.id;
            let status = res.data.status;
            if (status !== 'preparing') {
                dispatch('clearCart', type);
            }

            return {
                id: orderId,
                status: status,
            }
        });
    },
    async initCheckout({ commit, dispatch }, type) {
        let cartOrder = localStorage.getItem(`cart-order-${type}`);
        if (! cartOrder) {
            commit(types.INIT_CART, type);
            dispatch('initLastLocation', type);
            dispatch('trialCalculate', type);

            return;
        }

        commit(types.INIT_TRIAL);
        commit(types.LOAD_LOCAL_STORAGE_CART, JSON.parse(cartOrder));
        await dispatch('trialCalculate', type);
    },
    setCartData({ commit, state, dispatch }, data) {
        commit(types.SET_CART_DATA, data);
        commit(types.CLEAR_CART_ID);
        commit(types.SAVE_LOCAL_STORAGE_CART);
        if (['tip_price', 'reserved_at', 'coupon_id', 'wait_hours'].indexOf(data.key) >= 0) {
            dispatch('trialCalculate', state.order.type);
        }
    },
    async addCartLocation({ commit, state, dispatch }, location) {
        commit(types.ADD_CART_LOCATION, location);
        commit(types.CLEAR_CART_ID);
        commit(types.SAVE_LOCAL_STORAGE_CART);
        await dispatch('initLiquorShopLocation');
        dispatch('trialCalculate', state.order.type);
    },
    putCartLocation({ commit, state, dispatch }, data) {
        commit(types.PUT_CART_LOCATION, data);
        commit(types.CLEAR_CART_ID);
        commit(types.SAVE_LOCAL_STORAGE_CART);
        dispatch('trialCalculate', state.order.type);
    },
    putCartProduct({ commit }, data) {
        commit(types.PUT_CART_PRODUCT, data);
        commit(types.CLEAR_CART_ID);
        commit(types.SAVE_LOCAL_STORAGE_CART);
    },
    deleteCartProduct({ commit }, data) {
        commit(types.DELETE_CART_PRODUCT, data);
        commit(types.CLEAR_CART_ID);
        commit(types.SAVE_LOCAL_STORAGE_CART);
    },
    addProductToLocation({ commit }, data) {
        commit(types.PUT_CART_LOCATION_PRODUCTS, data);
        commit(types.CLEAR_CART_ID);
        commit(types.SAVE_LOCAL_STORAGE_CART);
    },
    sortCartLocations({ commit, state, dispatch }, locations) {
        commit(types.SORT_CART_LOCATIONS, locations);
        commit(types.CLEAR_CART_ID);
        commit(types.SAVE_LOCAL_STORAGE_CART);
        dispatch('trialCalculate', state.order.type);
    },
    deleteCartLocationByKey({ commit, state, dispatch }, key) {
        commit(types.DELETE_CART_LOCATION_BY_KEY, key);
        commit(types.CLEAR_CART_ID);
        commit(types.SAVE_LOCAL_STORAGE_CART);
        dispatch('trialCalculate', state.order.type);
    },
    async putCartLastLocation({ commit, state, dispatch }, location) {
        commit(types.PUT_CART_LAST_LOCATION, location);
        commit(types.CLEAR_CART_ID);
        commit(types.SAVE_LOCAL_STORAGE_CART);
        await dispatch('initLiquorShopLocation');
        dispatch('trialCalculate', state.order.type);
    },
    clearCart({ commit, state, dispatch }, type) {
        type = type || state.order.type;
        localStorage.removeItem(`cart-order-${type}`);
        state.photos[type] = [];
        commit(types.INIT_CART, type);
        dispatch('trialCalculate', type);
    },
    setCartCoupon({ commit, state, dispatch }, coupon) {
        commit(types.SET_CART_COUPON, coupon);
        commit(types.CLEAR_CART_ID);
        dispatch('trialCalculate', state.order.type);
    },
    trialCalculate({ commit, state }, type) {
        let locations = [].concat(state.order.locations);
        if (state.order.type !== 'transport') {
            locations = locations.concat([state.order.lastLocation]);
        }
        locations = locations.filter(location => location.road);

        let payload = {
            type: type,
            tip: state.order.tip_price,
            multiple: locations.length,
            coupon_id: state.coupon ? state.coupon.id : 0,
            reserved_at: state.order.reserved_at,
            wait_hours: state.order.wait_hours || 0,
        };

        if (state.trial.location_distance) {
            payload.distance = state.trial.location_distance;
            payload.duration = state.trial.location_duration;
        }
        payload.locations = locations;

        return apis.trial(payload).then(res => {
            commit(types.TRIAL_CALCULATE, res.data);
        });
    },
    setSelectedDriver({ commit, state }) {
        let driver = R.clone(state.order.confirmDriver);
        commit(types.SET_DRIVER, driver);
    },
    confirmDriver({ commit, state }) {
        let driver = R.clone(state.order.driver);
        commit(types.SET_CONFIRM_DRIVER, driver);
        commit(types.CLEAR_CART_ID);
        commit(types.SAVE_LOCAL_STORAGE_CART);
    }
};

const mutations = {
    [types.SET_CART_DATA](state, data) {
        state.order[data.key] = data.value;
    },
    [types.ADD_CART_LOCATION](state, location) {
        state.order.locations.push(location);
        state.trial.location_distance = 0;
        state.trial.location_duration = 0;
        state.trial.order_duration = 0;
    },
    [types.SET_CART_LOCATIONS](state, locations) {
        state.order.locations = locations;
        state.trial.location_distance = 0;
        state.trial.location_duration = 0;
        state.trial.order_duration = 0;
    },
    [types.PUT_CART_LOCATION](state, data) {
        state.order.locations.splice(data.key, 1, data.location);
        state.trial.location_distance = 0;
        state.trial.location_duration = 0;
        state.trial.order_duration = 0;
    },
    [types.PUT_CART_PRODUCT](state, data) {
        let location = R.clone(state.order.locations[data.index]);
        location.products[data.productIndex] = data.product;
        state.order.locations.splice(data.index, 1, location);
    },
    [types.DELETE_CART_PRODUCT](state, data) {
        let location = R.clone(state.order.locations[data.index]);
        location.products.splice(data.productIndex, 1);
        if (location.products.length || location.note) {
            state.order.locations.splice(data.index, 1, location);
        } else {
            state.order.locations.splice(data.index, 1);
        }
    },
    [types.PUT_CART_LOCATION_PRODUCTS](state, data) {
        let location = state.order.locations[data.key];
        if (!location.products) {
            location.products = data.products;
        } else {
            location.products = location.products.concat(data.products);
        }
        state.order.locations.splice(data.key, 1, location);
    },
    [types.SORT_CART_LOCATIONS](state, locations) {
        state.order.locations = locations;
        state.trial.location_distance = 0;
        state.trial.location_duration = 0;
        state.trial.order_duration = 0;
    },
    [types.DELETE_CART_LOCATION_BY_KEY](state, key) {
        state.order.locations.splice(key, 1);
        state.trial.location_distance = 0;
        state.trial.location_duration = 0;
        state.trial.order_duration = 0;
    },
    [types.PUT_CART_LAST_LOCATION](state, location) {
        state.order.lastLocation = location;
        state.trial.location_distance = 0;
        state.trial.location_duration = 0;
        state.trial.order_duration = 0;
    },
    [types.LOAD_LOCAL_STORAGE_CART](state, cartOrder) {
        cartOrder.locations = R.map(location => {
            if (!state.photos[cartOrder.type]) {
                location.photos = [];
                return location;
            }
            location.photos = R.map(photo => {
                return state.photos[cartOrder.type][photo] || null;
            }, location.photos || []);
            location.photos = R.filter(photo => {
                return photo != null;
            }, location.photos || []);
            return location;
        }, cartOrder.locations || []);
        if (cartOrder.lastLocation['photos']) {
            cartOrder.lastLocation.photos = R.map(photo => {
                return state.photos[cartOrder.type][photo] || null;
            }, cartOrder.lastLocation.photos || []);
            cartOrder.lastLocation.photos = R.filter(photo => {
                return photo != null;
            }, cartOrder.lastLocation.photos || []);
        }
        state.order = cartOrder;
    },
    [types.INIT_CART](state, type) {
        state.order = {
            id: 0,
            tip_price: null,
            reserved_at: null,
            expected_price: null,
            coupon_id: null,
            type: type,
            agreement_id: null,
            pay: null,
            note: '',
            locations: [],
            products: [],
            lastLocation: {},
            no_touch: 0,
            wash_count: 1,
            driver: null,
            behalf_fee_vat: null,
        };

        state.trial = {
            base: 119,
            distance: 0,
            multiple: 0,
            tip: 0,
            discount: 0,
            night_surcharge: false,
            location_distance: 0,
            location_duration: 0,
            order_duration: 0,
        };

        if (type === 'transport') {
            state.order.locations.push({});
        }

        if (type === 'wait') {
            state.order.wait_hours = 1;
        }

        if (type === 'accompanying' || type === 'housekeeping') {
            state.order.wait_hours = 2;
        }

        state.coupon = null;
    },
    [types.INIT_CART_LAST_LOCATION](state, address) {
        state.order.lastLocation = address;
    },
    [types.SAVE_LOCAL_STORAGE_CART](state) {
        let order = R.clone(state.order);
        state.photos[state.order.type] = [];
        order.locations = R.map(location => {
            location.photos = R.map(photo => {
                let randomKey = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
                state.photos[state.order.type][randomKey] = photo;
                return randomKey;
            }, location.photos || []);
            return location;
        }, order.locations || []);
        if (order.lastLocation['photos']) {
            order.lastLocation.photos = R.map(photo => {
                let randomKey = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
                state.photos[state.order.type][randomKey] = photo;
                return randomKey;
            }, order.lastLocation.photos || []);
        }
        localStorage.setItem(`cart-order-${state.order.type}`, JSON.stringify(order));
    },
    [types.INIT_TRIAL](state) {
        state.trial = {
            base: 119,
            distance: 0,
            multiple: 0,
            tip: 0,
            discount: 0,
            night_surcharge: false,
            location_distance: 0,
            location_duration: 0,
            order_duration: 0,
        };
    },
    [types.TRIAL_CALCULATE](state, trial) {
        state.trial = trial;
    },
    [types.SET_CART_COUPON](state, coupon) {
        state.coupon = coupon;
    },
    [types.SET_CART_ID](state, order) {
        state.order.id = order.id;
    },
    [types.CLEAR_CART_ID](state) {
        state.order.id = 0;
    },
    [types.SET_CONFIRM_DRIVER](state, driver) {
        state.order.confirmDriver = driver;
    },
    [types.SET_DRIVER](state, driver) {
        state.order.driver = driver;
    }
};

export default {
    state,
    getters,
    actions,
    mutations,
};
